import { useState } from 'react';

export interface CopyButtonProps {
  readonly text: string;
  readonly label: string;
}

type CopyState = 'idle' | 'copied' | 'failed';

/** Copies {@code text} to the clipboard and briefly confirms it. */
export function CopyButton({ text, label }: CopyButtonProps) {
  const [state, setState] = useState<CopyState>('idle');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
    } catch {
      setState('failed');
    }
  };
  return (
    <button type="button" className="secondary outline" onClick={() => void copy()}>
      {state === 'copied' ? 'Copied!' : state === 'failed' ? 'Copy failed' : label}
    </button>
  );
}
